import React from "react";
import { Helmet } from "react-helmet";
import { RegistrationForm } from "./registarationForm";
import { getPageTitle } from "../../helpers/envTitle";

import "./style.css";

export const Registration = () => {
  return (
    <div className={"registration__page__wrapper"}>
      <Helmet>
        <title>{getPageTitle()}</title>
      </Helmet>
      <RegistrationForm />
    </div>
  );
};
